import { InputNumber } from 'antd';
import LOCALS from 'commons/locals';
import { findLabelByValue } from 'commons/options';
import i18n from 'i18n';
import { Control, Controller, FieldErrors, useWatch } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { FormLabel } from '../form-label';
import { CURRENCY_OPTION_LIST } from 'constant/currency';

const ProductCareCost = ({
  control,
  errors,
  disabled,
}: {
  control: Control<CreateProductFormSchemaType>;
  errors: FieldErrors<CreateProductFormSchemaType>;
  disabled: boolean;
}) => {
  const currency = useWatch({ control, name: 'currency' });

  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.care_cost)}:</FormLabel>
      <Controller
        name="careCost"
        control={control}
        render={({ field }) => {
          return (
            <div className="relative w-full">
              <InputNumber
                addonBefore={
                  currency
                    ? findLabelByValue(currency, CURRENCY_OPTION_LIST)
                    : null
                }
                {...field}
                value={field.value ?? null}
                status={errors.careCost ? 'error' : undefined}
                className="w-full"
                max={99999999}
                min={0}
                disabled={disabled}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/\$\s?|(,*)/g, '') as any}
                placeholder={i18n.t(LOCALS.please_enter) || ''}
              />
              {errors.careCost && (
                <p style={{ color: 'red' }} className="absolute left-0">
                  {i18n.t(LOCALS.required_field)}
                </p>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default ProductCareCost;
